import {BaseEntity,Column,Entity,Index,JoinColumn,JoinTable,ManyToMany,ManyToOne,OneToMany,OneToOne,PrimaryColumn,PrimaryGeneratedColumn,RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn} from "typeorm";

@Entity('value_addition_two_types')
export class ValueAdditionTwoType {

  @PrimaryGeneratedColumn("increment",{name:'value_addition_two_id'})
  valueAdditionTwoId:number;
 
  @Column("varchar",{
      nullable:false,
      length:20,
      name:"code"
      })
    code:string;

    @Column("varchar",{
      nullable:false,
      length:15,
      name:"name"
      })
    name:string;

    @Column("varchar",{
      nullable:true,
      length:50,
      name:"remarks"
      })
    remarks:string;

  @Column("boolean",{
    nullable:false,
    default:true,
    name:"is_active"
    })
  isActive:boolean;
  @CreateDateColumn({
    name: "created_at",
    type:"datetime"
  })
  createdAt: Date;

  @Column("varchar", {
      nullable: false,
      name: "created_user"
  })
  createdUser: string | null;


  @UpdateDateColumn({
      name: "updated_at",
      type:'datetime'
  })
  updatedAt: Date;

  @Column("varchar", {
      nullable: true,
      name: "updated_user"
  })
  updatedUser: string | null;


  @VersionColumn({
      default:1,
      name: "version_flag"
  })
  versionFlag: number;
  @OneToMany(type=>ValueAdditionTwoType, valueAdditionTwoType=>valueAdditionTwoType.valueAdditionTwoId,{cascade: true})
  valueAdditionTwoTypeInfo:ValueAdditionTwoType[];
}
